const initialTextures = [
  {
    name: "initialBG",
    type: "texture",
    path: "/hyundai-tco/bg/bg_0.webp",
  },
]

const sequenceBG = []
for (let i = 0; i <= 360; i++) {
  sequenceBG.push(`/hyundai-tco/bg/bg_${i}.webp`);
}
const couplesRotationTextures = []
for (let i = 0; i <= 45; i++) {
  couplesRotationTextures.push(`/hyundai-tco/rotation/rotation_${i}.webp`);
}

// Finale episode slider — 6 slides, each an image (prev/next peek cards,
// and the active card's poster) + a short looping video (active card
// only). No real copy exists yet — placeholder title/tag/caption, to be
// swapped in later. isStreamed/streamingLabel mirror the reference's
// TcoPhase2Slide shape (see EpisodeSlider.js/TcoPhase2NotifyFlip.js): a
// streamed episode shows the "take the quiz" pill when active, a
// non-streamed one shows the notify-me form instead. Hand-set here (no
// CMS) — only Episode 1 is streamed for now.
const episodesDir = "/hyundai-tco/episodes";
const episodes = [
  {
    image: `${episodesDir}/ep1.webp`,
    video: `${episodesDir}/EP1---Short.mp4`,
    title: "Episode 1",
    tag: "Introduction",
    caption: "Follow the mini series to find yours.",
    isStreamed: true,
  },
  {
    image: `${episodesDir}/ep2.webp`,
    video: `${episodesDir}/EP2---Short.mp4`,
    title: "Episode 2",
    tag: "Introduction",
    caption: "Follow the mini series to find yours.",
    isStreamed: false,
    streamingLabel: "Coming soon",
  },
  {
    image: `${episodesDir}/ep3.webp`,
    video: `${episodesDir}/EP3---Short.mp4`,
    title: "Episode 3",
    tag: "Introduction",
    caption: "Follow the mini series to find yours.",
    isStreamed: false,
    streamingLabel: "Coming soon",
  },
  {
    image: `${episodesDir}/Gemini_Generated_Image_6j5y846j5y846j5y-copy.webp`,
    video: `${episodesDir}/4-short.mp4`,
    title: "Episode 4",
    tag: "Introduction",
    caption: "Follow the mini series to find yours.",
    isStreamed: false,
    streamingLabel: "Coming soon",
  },
  {
    image: `${episodesDir}/Gemini_Generated_Image_doddb9doddb9dodd.webp`,
    video: `${episodesDir}/5-short.mp4`,
    title: "Episode 5",
    tag: "Introduction",
    caption: "Follow the mini series to find yours.",
    isStreamed: false,
    streamingLabel: "Coming soon",
  },
  {
    image: `${episodesDir}/Gemini_Generated_Image_rvukszrvukszrvuk-copy.webp`,
    video: `${episodesDir}/6-short.mp4`,
    title: "Episode 6",
    tag: "Introduction",
    caption: "Follow the mini series to find yours.",
    isStreamed: false,
    streamingLabel: "Coming soon",
  },
];

export { initialTextures, sequenceBG, couplesRotationTextures, episodes };